<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title flex_between">
      <span>
        <span>问诊费详情</span>
      </span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div class="box">
      <div class="container">
        <div class="infobox">
          <div class="info">
            <div>
              <span class="infotitle">用户昵称：</span>
              <span>{{ detail.nick_name }}</span>
            </div>
            <div style="margin: 14px 0">
              <span class="infotitle">性别：</span>
              <span>{{ detail.user_sex == 1 ? "男" : "女" }}</span>
            </div>
            <div>
              <span class="infotitle">手机号：</span>
              <span>{{ detail.user_phone }}</span>
            </div>
          </div>
          <div class="info" style="margin: 0 20px">
            <div>
              <span class="infotitle">患者姓名：</span>
              <span>{{ detail.real_name }}</span>
            </div>
            <div style="margin: 14px 0">
              <span class="infotitle">性别：</span>
              <span>{{ detail.patient_sex == 1 ? "男" : "女" }}</span>
            </div>
            <div>
              <span class="infotitle">年龄：</span>
              <span>{{ detail.age }}</span>
            </div>
          </div>
          <div class="info">
            <div>
              <span class="infotitle">医生姓名：</span>
              <span
                @click="showDocMsg(detail.doctor_id)"
                style="cursor: pointer"
                >{{ detail.doctor_name }}</span
              >
            </div>
            <div style="margin: 14px 0">
              <span class="infotitle">性别：</span>
              <span>{{ detail.doctor_sex == 1 ? "男" : "女" }}</span>
            </div>
            <div>
              <span class="infotitle">手机号：</span>
              <span>{{ detail.doctor_phone }}</span>
            </div>
          </div>
        </div>
        <div class="item">
          <div style="margin-bottom: 10px">
            <span>
              <span class="gray">交易单号：</span>
              <span>{{ detail.trade_no }}</span>
            </span>
            <span style="margin: 0 40px">
              <span class="gray">支付方式：</span>
              <span v-if="detail.pay_type == 1">微信支付</span>
              <span v-if="detail.pay_type == 2">支付宝支付</span>
            </span>
            <span>
              <span class="gray">支付来源：</span>
              <span v-if="detail.pay_from == 1">公众号</span>
              <span v-if="detail.pay_from == 2">患者App</span>
              <span v-if="detail.pay_from == 3">小程序</span>
            </span>
          </div>
          <div>
            <span class="gray">支付时间：</span>
            <span>{{ detail.pay_time }}</span>
            <span class="gray" style="margin-left: 100px">支付金额：</span>
            <span>{{ detail.pay_money }}</span>
          </div>
          <div style="margin-top: 10px" v-if="detail.settlement_status == 4">
            <span class="gray">退款时间：</span>
            <span>{{ detail.refund_time }}</span>
            <span class="gray" style="margin-left: 100px">退款金额：</span>
            <span>- {{ detail.refund_money }}</span>
          </div>
        </div>
        <div class="item">
          <div>
            <span style="color: #f24e33">问诊费用：</span>
            <span style="color: #f24b2f"
              >{{ detail.consult_fee }}&nbsp;&nbsp;</span
            >

            <span style="color: #f24e33">
              (
              <span v-if="detail.coupon_money != 0"
                >优惠券抵扣:{{ detail.coupon_money }}元&nbsp;&nbsp;</span
              >
              <span v-if="detail.gift_money != 0"
                >礼品卡抵扣:{{ detail.gift_money }}元&nbsp;&nbsp;</span
              >
              <span v-if="detail.pay_money != 0"
                >微信支付:{{ detail.pay_money }}元</span
              >
              )
            </span>
            <span style="color: #f24e33; margin-left: 30px">结算问诊费：</span>
            <span style="color: #f24b2f">{{ detail.settlement_money }}</span>
          </div>
          <div style="margin: 10px 0">
            <span class="gray">问诊结束时间：</span>
            <span>{{ detail.over_time }}</span>
          </div>

          <!-- <div style="margin: 10px 0">
            <span class="gray">问诊类型：</span>
            <span>{{ detail.consult_type | consultTypeText }}</span>
          </div> -->

          <div>
            <span class="gray">结束类型：</span>
            <span v-if="detail.status == 4">医生拒绝</span>
            <span v-if="detail.status == 5">问诊时间结束</span>
            <span v-if="detail.status == 6">超时未接诊</span>
            <span v-if="detail.status == 7">手动结束</span>
            <span v-if="detail.status == 8">超时未发起</span>
          </div>
          <div style="margin-top: 10px" v-if="detail.status == 4">
            <span class="gray">原因：</span>
            <span>{{ detail.refuse_desc }}</span>
          </div>
        </div>

        <div class="item">
          <div>
            <span class="gray">结算状态：</span>
            <span v-if="detail.settlement_status == 1">待系统核算</span>
            <span v-if="detail.settlement_status == 2">待结算</span>
            <span v-if="detail.settlement_status == 3">已结算</span>
            <span v-if="detail.settlement_status == 4">已退款</span>
          </div>
          <div
            v-if="
              detail.settlement_status == 2 || detail.settlement_status == 3
            "
            style="margin-top: 10px"
          >
            <div>
              <span class="gray">完成时间：</span>
              <span>{{ detail.psa_time }}</span>
            </div>
            <div style="margin-top: 10px">
              <span class="gray">结算帐期：</span>
              <span>{{ detail.period }}</span>
            </div>
            <div style="margin-top: 10px" v-if="detail.settlement_status == 3">
              <span class="gray">结算入账时间：</span>
              <span>{{ detail.sa_time }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import doctor_fee from "../../../api/doctor_fee";
import platform from "../../../api/platform";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      detail: {},
      doc_msg: false,
      doctorId: "",
    };
  },
  components: {
    DocMsg,
  },
  filters: {
    consultTypeText(val) {
      switch (val) {
        case 1:
          return "患者发起咨询";
        case 2:
          return "医生赠送咨询";
        case 3:
          return "患者发起诊后服务";
        case 4:
          return "预约咨询";
        case 5:
          return "极速问诊";
      }
    },
  },
  methods: {
    back() {
      history.back();
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    getDetail() {
      let consult_id = this.$route.query.consult_id;
      doctor_fee.getConsultCostInfo({ consult_id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data.info;
          this.detail.pay_time = platform.timestampToTime(this.detail.pay_time);
          this.detail.over_time = platform.timestampToTime(
            this.detail.over_time
          );
          this.detail.settlement_money = this.detail.settlement_money
            ? this.detail.settlement_money.toFixed(2)
            : " this.detail.settlement_money";
          this.detail.refund_time = this.detail.refund_time
            ? platform.timestampToTime(this.detail.refund_time)
            : "";
          this.detail.psa_time = this.detail.psa_time
            ? platform.timestampToTime(this.detail.psa_time)
            : "";
          this.detail.period = this.detail.period
            ? platform.timestampToDate(this.detail.period).slice(0, 7)
            : "";
          this.detail.sa_time = this.detail.sa_time
            ? platform.timestampToTime(this.detail.sa_time)
            : "";
        }
      });
    },
  },
  created() {
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
.box {
  padding: 20px;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.infobox {
  display: flex;
  .info {
    background-color: #f9f8ee;
    border: solid 1px #dad8ca;
    padding: 14px 60px 14px 20px;
  }
}
.item {
  border: solid 1px #cfcece;
  padding: 20px;
  margin-top: 20px;
}
.gray {
  color: #747981;
}
.infotitle {
  display: inline-block;
  width: 75px;
}
</style>
